import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS } from '@framework/workbench/ui/save-revision/config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { SaveRevisionFeature } from '@framework/workbench/ui/save-revision/save-revision-feature';
import { isClientDriveFile } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

@Controller({ menuItems: MENU_CONFIGS })
export class SaveRevisionController {
    constructor(private readonly feature: SaveRevisionFeature) {
    }

    @Menu(ActionType.SAVE_REVISION, 'onClick')
    public saveRevision() {
        this.feature.saveRevision();
    }

    @Menu(ActionType.SAVE_REVISION, 'shouldHide')
    public handleHide() {
        return isClientDriveFile() || ENV.IS_LOCAL_EDIT;
    }
}
